import styled, { css } from 'styled-components'
import { CardBody, Row } from 'shards-react'

export const CustomizedCardBody = styled(CardBody)`
    width: 100%;
`
export const RowWithNativeExperience = styled(Row)`
    ${({ nativeExperience }) => {
        if (nativeExperience === false) {
            return css`
                display: none;
            `
        }
    }}
`
